import React from 'react';

import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../../../../shared/components/table-components';
import { SortButtons } from '../../../../../../../shared/components/buttons';
import { participantsListStore } from '../../../../../../stores/participantsListStore';

const TitleRow = observer(() => {
  const { filterMethods } = participantsListStore;
  const { handleSort, getIsSortedBy } = filterMethods;

  return (
    <GridTableRow variant="header" dataTestId="participants-header-row">
      <GridTableCell>
        <SortButtons
          fieldName="PARTICIPANT_NAME"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Name
        </SortButtons>
      </GridTableCell>
      <GridTableCell>Name displayed on the leaderboard</GridTableCell>
      <GridTableCell>
        <SortButtons fieldName="DIVISION" onSort={handleSort} getIsActive={getIsSortedBy}>
          Division
        </SortButtons>
      </GridTableCell>
      <GridTableCell>
        <SortButtons
          fieldName="INITIAL_SCAN_DATE"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Initial Scan Date
        </SortButtons>
      </GridTableCell>
      <GridTableCell>
        <SortButtons
          fieldName="LAST_SCAN_DATE"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Last Scan Date
        </SortButtons>
      </GridTableCell>
      <div />
    </GridTableRow>
  );
});

export { TitleRow };
